import { EditorState, Transaction } from '@tiptap/pm/state';
import { Node, Fragment } from '@tiptap/pm/model';

export const isUndoRedo = (transactions: readonly Transaction[]): boolean =>
    transactions.some((transaction) => transaction.getMeta('history$'));

export const hasDocChanges = (
    transactions: readonly Transaction[],
    oldState: EditorState,
    newState: EditorState,
): boolean => transactions.some((transaction) => transaction.docChanged) && !oldState.doc.eq(newState.doc);

/**
 * Safely insert content at a position, handling potential edge cases
 */
export const safeInsert = (tr: Transaction, pos: number, content: Fragment | Node): boolean => {
    // Check position bounds
    if (pos < 0 || pos > tr.doc.content.size - 2) {
        return false;
    }

    try {
        tr.insert(pos, content);
        return true;
    } catch (error) {
        return false;
    }
};

/**
 * Safely delete content between positions
 */
export const safeDelete = (tr: Transaction, from: number, to: number): boolean => {
    // Check position bounds and validity
    if (from < 0 || to > tr.doc.content.size - 2 || from >= to) {
        return false;
    }

    try {
        tr.delete(from, to);
        return true;
    } catch (error) {
        return false;
    }
};
